import { render, staticRenderFns } from "./LessonChart.vue?vue&type=template&id=298ade62&scoped=true&"
import script from "./LessonChart.vue?vue&type=script&lang=js&"
export * from "./LessonChart.vue?vue&type=script&lang=js&"
import style0 from "./LessonChart.vue?vue&type=style&index=0&id=298ade62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298ade62",
  null
  
)

export default component.exports